<script>
import HourService from "@/store/services/hour.service.js";
import TotalAmountsBase from "@/components/base_components/TotalAmountsBase.vue";

export default {
  name: "TotalAmountsHour",
  extends: TotalAmountsBase,
  data() {
    return {
      mutationName: 'hourStore/SET_REFRESH_TOTALS'
    }
  },
  methods: {
    getTotalAmounts(){
      if((!this.$store.getters["hourStore/getRefreshComponent"] || this.$store.getters["hourStore/getRefreshComponent"] === this.$options.name)) {
        if(Object.keys(this.filters).length !== 0){
          this.loading = true
          let filters = { ...this.filters }
          filters.exclude_archived = "True"
          if(!filters.company_profile){
            filters.company_profile = window.company_id;
          }
          if(!filters.project) {
            filters.project__company = this.$store.getters["filterStore/getCurrentCustomer"]
          } 
          filters.extended = "False";
          this.$nextTick(() => {
            HourService.getTotals(filters).then((response) => {
              this.loading = false
              this.amountsList = [];
              this.amountsList.push({text: this.$gettext("Unassigned"), amount: response.data.unassigned, class:'text-unassigned'});
              this.amountsList.push({text: this.$gettext("Uninvoiced"), amount: response.data.uninvoiced, class:'text-uninvoiced'});
              this.amountsList.push({text: this.$gettext("Invoiced"), amount: response.data.invoiced, class:'text-invoiced'});
              this.amountsList.push({text: this.$gettext("Total"), amount: response.data.total, class:'text-blue'});
            })
          })
        }
      }
    }
  }
};
</script>